<template>
  <div>
    <div class="search-box shadow-sm d-flex py-1 px-3">
      <form @submit.prevent="getAllDebtors">
        <div class="row">
          <div class="col-md-4 d-flex flex-row">
            <div class="form-floating mx-1" style="width: 80%">
              <input type="text" class="form-control"
                     v-model="form.Name" id="customerName"
                     placeholder="Customer Name">
              <label for="customerName">Customer Name</label>
            </div>
            <button class="lyt-soft-btn h-100" type="button" style="width: 15%;" @click="createDebtor">
              <font-awesome-icon icon="fa-solid fa-plus"/>
            </button>
          </div>

          <div class="col-md-4">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.tpin" id="customerTPIN"
                     placeholder="TPIN">
              <label for="customerTPIN">TPIN</label>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.contact" id="customerContact"
                     placeholder="Contact No.">
              <label for="customerContact">Contact No.</label>
            </div>
          </div>

          <button class="lyt-soft-btn" type="submit">SEARCH</button>
        </div>
      </form>
    </div>

    <div class="text-center d-flex justify-content-between align-items-center px-3 m-2">
      <span>Sale Total :</span>
      <h3 class="fw-bold m-0">{{ $utils.formatMoney((saleTotal - discount.total)) }}</h3>
    </div>

    <DynamicScroller
        :items="debtors"
        key-field="Id"
        :min-item-size="141"
        class="list-body h-100 w-100">
      <template v-slot="{ item, index, active }">
        <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index">
          <DebtorListItem :debtor="item" @click="chooseAction(item)"/>
        </DynamicScrollerItem>
      </template>
    </DynamicScroller>
  </div>
</template>

<script>
import DebtorListItem from "@/components/point-of-sale/Accounts/DebtorListItem";

export default {
  name: "SelectCustomer",
  components: {DebtorListItem},
  computed: {
    saleTotal() {
      return this.$store.getters.getSaleTotal
    },
    discount() {
      return this.$store.getters.getSaleDiscount
    },
    debtors() {
      return this.$store.getters.getDebtors;
    },
  },
  data() {
    return {
      form: {
        Name: "",
        tpin: "",
        contact: ""
      }
    }
  },
  methods: {
    getAllDebtors() {
      this.$utils.showLoading();
      return this.$store.dispatch('getAllDebtors', this.form)
          .finally(() => this.$utils.hideLoading());
    },

    chooseAction(debtor) {
      return Swal.fire({
        icon: 'question',
        title: `Save Order<br><h6>Debtor : ${debtor.Name} ${debtor.Surname}</h6>`,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        denyButtonColor: `rgb(88, 125, 224)`
      }).then((result) => {
        if (result.isConfirmed) {
          return this.quoteCustomer(debtor);
        } else if (result.isDismissed) {
          this.$store.commit(`setCustomer`, '');
        }
      })
    },

    quoteCustomer(debtor) {
      this.loading = true;
      this.$store.commit('setIsTabOpen', true)
      let input = `${debtor.Name}-${currentDate()}`;
      return this.$store.dispatch('saveNewTable', {
        name: input,
        Customer: debtor.Id,
      }).then((res) => {
        this.$store.commit('setIsTabOpen', false)
        return Swal.fire({
          icon: `success`,
          title: `Order Saved<br> <h6>Reference : ${input}</h6>`,
          showCancelButton: true,
          confirmButtonText: 'Download',
          cancelButtonText: 'Next Order',
        }).then((result) => {
          if (result.isConfirmed) {
            let quote = res.SaleNum;
            this.$store.dispatch(`downloadQuote`, quote);
          }
          return this.$router.push({name: 'pos'})
        })


      }).finally(() => this.loading = false)
    },
    createDebtor() {
      return this.$router.push({name: "create-debtor"})
    }
  },
  beforeDestroy() {
    this.$store.commit(`setDebtors`, []);
  }
}
</script>

<style lang="scss" scoped>

.search-box {
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 1;
}

.col-md-4 {
  margin-bottom: 10px;

}
</style>